import { DialogProps } from '@material-ui/core';
import React from 'react';
import { entPhysiciansCommand_patchOfficeAddress, IAddressModel, IEntPhysician, IOfficeData } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import { AddressForm } from 'shared/address/AddressForm';

interface IProps extends DialogProps {
	entPhysician: IEntPhysician;
	office: IOfficeData;
	confirm: VoidFunction;
	cancel: VoidFunction;
}

const toModel = (office: IOfficeData): IAddressModel => {
	return {
		addressLine: office.addressLine,
		zip: office.zip,
		city: office.city,
		country: office.country,
	};
};

export const PatchEntPhysicianOfficeAddressForm = ({ entPhysician, office, confirm, cancel, ...rest }: IProps) => {
	const strings = useLocalization();

	return (
		<AddressForm
			cancel={cancel}
			model={toModel(office)}
			confirm={confirm}
			submitFunction={model => entPhysiciansCommand_patchOfficeAddress({ entPhysicianId: entPhysician.id, officeId: office.id, address: model })}
			successMessage={strings.addressUpdated}
			{...rest}
		/>
	);
};
